/**
 * Helper to set test id data attributes.
 *
 * Provides consistent setting + ability to track test id usage.
 *
 * @example
 * <MyElement {...testId('some-unique-test-key')}/>
 */ const setTestId = (testId)=>{
    return testId ? {
        ["data-test-id"]: testId
    } : {};
};

export { setTestId };
